/** *
 * @description iconfont SVG图标
 */
import { Icon } from 'ant-design-vue'
const BSvgIcon = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1206844_8g1x8a4n2db.js'
})

export default BSvgIcon
